import React, {Component} from "react";
import Select from "react-select";
import ErrorSpan from "../ErrorSpan";

export default class SelectInput extends Component {
    constructor() {
        super(...arguments);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(value) {
        this.props.onChange(this.props.attribute, value.value, value.label);
    }

    render() {
        const options = _.map(this.props.options, ((name, id) => {
            let disabled = this.props.disabled || [];
            if (disabled.includes(id)) {
                return {value: id, label: name, isDisabled: true};
            } else {
                return {value: id, label: name};
            }
        }));

        if(this.props.optionsSortCallback) {
            options.sort(this.props.optionsSortCallback);
        }

        const selected = options.find((el) => {return +el.value === +this.props.value}) || this.props.selected;
        const {attribute, label, isDisabled, required, error} = this.props;

        return (
            <div className="form-group">
                <label htmlFor={attribute}>
                    {label}
                    {required && <span className="text-danger">*</span>}
                </label>
                <Select
                    value={selected || {value: '', label: 'Оберіть'}}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    onChange={this.handleChange}
                    options={options}
                    isDisabled={isDisabled}
                />
                {error && <ErrorSpan error={error}/>}
            </div>
        )
    }
}
